import ActionsForm from '@/shared/mixins/actionsForm'
import ExpenseMixin from '@/views/private/finance/expenses/travelexpensezpag/mixins/ExpenseMixin'
import qmaTemplate from '@/shared/http/repositories/business/qmaTemplate'
import { toast } from '@/shared/utils/UIHelper'

export default {
  name: 'templateFilter',
  components: {},
  props: ['TipoQmaTemplate'],
  mixins: [ ActionsForm, ExpenseMixin ],
  data () {
    return {
      form: {
        Qma: null,
        InicioDataSolicitacao: null,
        FimDataSolicitacao: null,
        TipoStatus: null
      },
      dataStatusQMATemplate: []
    }
  },
  watch: {
    'form.InicioDataSolicitacao' (value) {
      if (this.form.FimDataSolicitacao != null) {
        if (this.form.InicioDataSolicitacao > this.form.FimDataSolicitacao) {
          this.form.FimDataSolicitacao = null
          toast.warning('A date Desde deve ser menor que a data Até')
        }
      }
    },
    'form.FimDataSolicitacao' (value) {
      if (this.form.InicioDataSolicitacao != null) {
        if (this.form.InicioDataSolicitacao > this.form.FimDataSolicitacao) {
          this.form.InicioDataSolicitacao = null
          toast.warning('A date Desde deve ser menor que a data Até')
        }
      }
    }
  },
  mounted () {
    this.GetStatusQMATemplate()
  },
  methods: {
    Search () {
      this.$emit('search', {QMA: this.form.Qma, dataInicio: this.form.InicioDataSolicitacao, dataFim: this.form.FimDataSolicitacao, TipoStatus: this.form.TipoStatus})
    },
    onClearSection () {
      this.form.Qma = null
      this.form.InicioDataSolicitacao = null
      this.form.FimDataSolicitacao = null
      this.form.TipoStatus = null
      this.Search()
    },
    GetStatusQMATemplate () {
      qmaTemplate.GetStatusTemplateQMA()
        .then((Response) => {
          this.dataStatusQMATemplate = Response.data
        })
        .catch((Error) => {
          console.warning('Status não encontrado')
        })
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/qma/qmaTemplate/TemplateFilter/templateFilter.js